module.exports = __webpack_public_path__ + "img/44.cleaner.c8f68093.svg";